export { default as DefaultPage } from './DefaultPage';
export { default as AfilePage } from './AfilePage';



// WEBPACK FOOTER //
// ./src/features/file/index.js